const medicaidEligibilityStatus = Object.freeze({
  Submitted: 1,
  Approved: 2,
  Denied: 3,
});

export default medicaidEligibilityStatus;
